import { render, staticRenderFns } from "./NavFastCreationMenu.vue?vue&type=template&id=94affbfc&"
import script from "./NavFastCreationMenu.vue?vue&type=script&lang=js&"
export * from "./NavFastCreationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94affbfc')) {
      api.createRecord('94affbfc', component.options)
    } else {
      api.reload('94affbfc', component.options)
    }
    module.hot.accept("./NavFastCreationMenu.vue?vue&type=template&id=94affbfc&", function () {
      api.rerender('94affbfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/NavFastCreationMenu.vue"
export default component.exports